import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ProductCardImageComponent } from '@app/shared-product/components/product-card-image/product-card-image.component';
import { BetterBuySavingsComponent } from './components/better-buy-savings/better-buy-savings.component';
import { UsfChipComponent } from './components/usf-chip/usf-chip.component';
import { SharedModule } from '@shared/shared.module';
import { ProductCardInformationComponent } from './components/product-card-information/product-card-information.component';
import { ProductCardOrderingComponent } from './components/product-card-ordering/product-card-ordering.component';
import { ProductCardItemNoteComponent } from './components/product-card-item-note/product-card-item-note.component';
import { ProductCardPromotionsBannerComponent } from './components/product-card-promotions-banner/product-card-promotions-banner.component';
import { ProductCardLineNumberComponent } from './components/product-card-line-number/product-card-line-number.component';
import { ProductCardEllipsisComponent } from './components/product-card-ellipsis/product-card-ellipsis.component';
import { ProductCardDrawerComponent } from './components/product-card-drawer/product-card-drawer.component';
import { ProductConversionContainerComponent } from './components/product-conversion/product-conversion-container/product-conversion-container.component';
import { OriginalProductForConversionComponent } from './components/product-conversion/original-product-for-conversion/original-product-for-conversion.component';
import { ReplacementProductForConversionComponent } from './components/product-conversion/replacement-product-for-conversion/replacement-product-for-conversion.component';
import { UsfProductCardNonSplitComponent } from './components/usf-product-card-non-split/usf-product-card-non-split.component';
import { UsfProductCardSplitOriginalComponent } from './components/usf-product-card-split-original/usf-product-card-split-original.component';
import { UsfProductCardSplitAlternativeComponent } from './components/usf-product-card-split-alternative/usf-product-card-split-alternative.component';
import { UsfBetterBuyCardDesktopComponent } from './components/usf-better-buy-card/desktop/usf-better-buy-card-desktop.component';
import { UsfBetterBuyCardTouchComponent } from './components/usf-better-buy-card/touch/usf-better-buy-card-touch.component';
import { UsfBetterBuyDeclineModalComponent } from './components/usf-better-buy-decline-modal/usf-better-buy-decline-modal.component';
import { UsfProductTagListComponent } from './components/usf-product-tag-list/usf-product-tag-list.component';
import { UsfProductCardDesktopComponent } from './components/usf-product-card/desktop/usf-product-card-desktop.component';
import { UsfProductCardTouchComponent } from './components/usf-product-card/touch/usf-product-card-touch.component';
import { UsfProductCardInfoTouchComponent } from './components/usf-product-card-info/touch/usf-product-card-info-touch.component';
import { WorksWellWithContainerComponent } from './components/works-well-with/container/works-well-with-container.component';
import { WorksWellWithModalComponent } from './components/works-well-with/modal/works-well-with-modal';
import { PowerCustomReviewRatingStarsComponent } from './components/power-review-rating-stars/power-custom-review-rating-stars.component';
import { FormsModule } from '@angular/forms';
import { PricingModule } from '@app/pricing/pricing.module';
import { UsfPmeProductCardComponent } from './components/usf-pme-product-card/usf-pme-product-card.component';
import { ManualApprovalComponent } from './components/manual-approval/manual-approval.component';
import { PMERightRailComponent } from './components/pme-right-rail/pme-right-rail.component';
import { PmeSortFilterComponent } from './components/pme-sort-filter/pme-sort-filter.component';
import { ReplaceProductComponent } from '@app/lists/shared/replace-product/replace-product.component';
import { ProductDetailAddToOrderModalComponent } from './components/product-detail-add-to-order-modal/product-detail-add-to-order-modal.component';
import { ProductDetailCardComponent } from './components/product-detail-card/product-detail-card.component';
import { ProductDetailCABCardComponent } from './components/product-detail-cab-card/product-detail-cab-card.component';
import { MerchandisingProductCarouselComponent } from './components/merchandising-product-carousel/merchandising-product-carousel.component';
import { RecommendationCarouselComponent } from './components/recommendation-carousel/recommendation-carousel.component';
import { SearchResultNotFoundComponent } from './components/search-result-not-found/search-result-not-found.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    RouterModule,
    SharedModule,
    FormsModule,
    PricingModule,
  ],
  declarations: [
    BetterBuySavingsComponent,
    UsfChipComponent,
    ProductCardImageComponent,
    ProductCardInformationComponent,
    ProductCardOrderingComponent,
    ProductCardItemNoteComponent,
    ProductCardPromotionsBannerComponent,
    ProductCardLineNumberComponent,
    ProductCardEllipsisComponent,
    ProductCardDrawerComponent,
    ProductConversionContainerComponent,
    OriginalProductForConversionComponent,
    ReplacementProductForConversionComponent,
    UsfProductCardNonSplitComponent,
    UsfProductCardSplitOriginalComponent,
    UsfProductCardSplitAlternativeComponent,
    UsfBetterBuyCardDesktopComponent,
    UsfBetterBuyCardTouchComponent,
    UsfBetterBuyDeclineModalComponent,
    UsfProductCardDesktopComponent,
    UsfProductCardTouchComponent,
    UsfProductCardInfoTouchComponent,
    UsfProductTagListComponent,
    WorksWellWithContainerComponent,
    WorksWellWithModalComponent,
    PowerCustomReviewRatingStarsComponent,
    UsfPmeProductCardComponent,
    PMERightRailComponent,
    ManualApprovalComponent,
    PmeSortFilterComponent,
    ReplaceProductComponent,
    ProductDetailAddToOrderModalComponent,
    ProductDetailCardComponent,
    ProductDetailCABCardComponent,
    MerchandisingProductCarouselComponent,
    RecommendationCarouselComponent,
    SearchResultNotFoundComponent,
  ],
  exports: [
    BetterBuySavingsComponent,
    UsfChipComponent,
    ProductCardImageComponent,
    ProductCardInformationComponent,
    ProductCardOrderingComponent,
    ProductCardItemNoteComponent,
    ProductCardPromotionsBannerComponent,
    ProductCardLineNumberComponent,
    ProductCardEllipsisComponent,
    ProductCardDrawerComponent,
    ProductConversionContainerComponent,
    OriginalProductForConversionComponent,
    ReplacementProductForConversionComponent,
    UsfProductCardNonSplitComponent,
    UsfProductCardSplitOriginalComponent,
    UsfProductCardSplitAlternativeComponent,
    UsfBetterBuyCardDesktopComponent,
    UsfBetterBuyCardTouchComponent,
    UsfBetterBuyDeclineModalComponent,
    UsfProductCardDesktopComponent,
    UsfProductCardTouchComponent,
    UsfProductCardInfoTouchComponent,
    UsfProductTagListComponent,
    WorksWellWithContainerComponent,
    WorksWellWithModalComponent,
    UsfPmeProductCardComponent,
    PMERightRailComponent,
    ManualApprovalComponent,
    PmeSortFilterComponent,
    ReplaceProductComponent,
    ProductDetailAddToOrderModalComponent,
    ProductDetailCardComponent,
    ProductDetailCABCardComponent,
    MerchandisingProductCarouselComponent,
    RecommendationCarouselComponent,
    SearchResultNotFoundComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedProductModule {}
